<template>
    <div class="box">
  
      <a-row :gutter="24">
        <a-col :md="24">
          <a-menu v-model="current" mode="horizontal">
            <a-menu-item key="traceModule">追溯模版</a-menu-item>
            <a-menu-item key="H5Module">H5模版</a-menu-item>
            <a-menu-item key="printRule">打印模版</a-menu-item>
          </a-menu>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <div v-if="current[0] === 'traceModule'">
        <!-- 追溯模版内容 -->
        <trace-list></trace-list>
      </div>
      <div v-else-if="current[0] === 'H5Module'">
        <!-- H5模版内容 -->
        <template-list></template-list>
      </div>
      <div v-else-if="current[0] === 'printRule'">
        <!-- 打印模版内容 -->
        <label-template></label-template>
      </div>
      </a-row>
      <!-- 新增/编辑区域 -->
      
    </div>
  </template>
  
  <script>
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import TraceList from './traceList'
    import TemplateList from '../H5Create/templateList'
    import LabelTemplate from '@/views/UDIadmin/Labeltemplate'
    export default {
      name: "list",
      mixins:[JeecgListMixin],
      components: {
        TraceList,
        TemplateList,
        LabelTemplate
      },
      data() {
        return {
          current: ['traceModule'], // 顶部导航栏
          bindInfo:{},
          // 查询区域布局
          labelCol: {
            span: 5
          },
          wrapperCol: {
            span: 18,
            offset: 1
          },
  
          // 查询条件
          queryParam: {
            isStandard: '1'
          },
          url: {
            list: "/codeRules/fzRule/list",
            delete: "/codeRules/fzRule/delete",
            deleteBatch: "/codeRules/fzRule/deleteBatch"
          },
          visibleRuleNode: false, // 规则节点抽屉开关
          uuid: '', // 每一项的uuid
        }
      },
      methods: {
       
        bindTraceTemplate(record){
          this.$refs.bindTemplate.open(record) // 绑定追溯模版
        },
        // 规则节点抽屉关闭 - 点击事件
        onClose() {
          this.visibleRuleNode = false;
        }
  
      },
      watch: {
        current() {
          this.queryParam.isStandard = this.current[0] === 'traceModule' ? '1' : '0' // 规则查询参数
          this.queryParam.isStandard = 
            this.current[0] === 'traceModule' ? '1' : 
            this.current[0] === 'H5Module' ? '2' : // 假设 'newOption' 对应的值为 '2'
            '0';
          this.loadData(1)
        }
      },
      created() {
        
      }
    }
  </script>
  
  <style scoped>
    @import '~@assets/less/common.less'
  </style>